import Banners from './Banners';

export default Banners;
